import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export interface TenantRow {
  id: string;
  name: string;
  slug: string;
  is_active: boolean;
  subscription_tier: string;
  plan_name: string;
  created_at: string;
  users: number;
  published_listings: number;
}

const tenantsKey = ["admin", "tenants"] as const;

export function useTenants() {
  return useQuery({
    queryKey: tenantsKey,
    queryFn: async () => {
      const { data, error } = await apiClient.GET(
        "/api/v1/organizations/admin/tenants",
      );
      if (error || !data) throw new Error("Failed to load tenants");
      return data as unknown as TenantRow[];
    },
  });
}

export function useUpdateTenant() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (vars: {
      id: string;
      subscription_tier?: string;
      is_active?: boolean;
    }) => {
      const { id, ...body } = vars;
      const { data, error } = await apiClient.PATCH(
        "/api/v1/organizations/{organization_id}",
        { params: { path: { organization_id: id } }, body },
      );
      if (error || !data) throw new Error("Failed to update tenant");
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantsKey }),
  });
}
